import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getExpediteShippingOrderHistory } from "@TKCCP/Services/tkccpExpediteShippingService";
import { ExpediteShippingOrderHistoryModel } from "@TKCCP/Types/ApiModels";


type HandlerType = Handler<
    {
        orderNumber: string;
    },
    {
        expediteShippingOrderHistory?: ExpediteShippingOrderHistoryModel;
    }
>;

const isNotFoundResponse = (error: any) => error && error.status === 404;

export const DispatchBeginLoadExpediteShippingOrderHistory: HandlerType = props => {
    props.dispatch({
        type: "Data/ExpediteShippingOrderHistory/BeginLoadExpediteShippingOrderHistory" as any,
        orderNumber : props.parameter.orderNumber,
        
    });
};


export const GetExpediteShippingOrderHistory: HandlerType = async props => {
    try {
        props.expediteShippingOrderHistory = await getExpediteShippingOrderHistory({
            orderNumber: props.parameter.orderNumber,
        });
    } catch (error) {
        if (isNotFoundResponse(error)) {
            logger.info(`The product with id "${props.parameter.orderNumber}" does not have product extension data.`);
        } else {
            throw error;
        }
    }
};

export const DispatchCompleteLoadExpediteShippingOrderHistory: HandlerType = props => {
    props.dispatch({
        type: "Data/ExpediteShippingOrderHistory/CompleteLoadExpediteShippingOrderHistory" as any,
        orderNumber: props.parameter.orderNumber,
        model: props.expediteShippingOrderHistory as any,
    });
};

export const chain = [
    DispatchBeginLoadExpediteShippingOrderHistory,
    GetExpediteShippingOrderHistory,
    DispatchCompleteLoadExpediteShippingOrderHistory,
];
const loadExpediteShippingOrderHistory = createHandlerChainRunner(chain, "LoadExpediteShippingOrderHistory");
export default loadExpediteShippingOrderHistory;
